import TripMapHotelMarker from './TripMapHotelMarker';
import type { TripMapHotelCardProps, TripMapHotels } from './types';

interface TripMapHotelMarkersProps {
  hotels: TripMapHotels;
  showAvailable: boolean;
  hotelCardProps: TripMapHotelCardProps;
  onAddHotel: (hotel: any) => void;
}

// The hotels of the trip's programs (suggested) and, while a hotel is being
// picked, the hotels of the list.
export default function TripMapHotelMarkers({
  hotels,
  showAvailable,
  hotelCardProps,
  onAddHotel,
}: TripMapHotelMarkersProps) {
  return (
    <>
      {hotels.suggested.map((hotel) => (
        <TripMapHotelMarker
          key={'map-sh-' + hotel?.id}
          hotel={hotel}
          onAdd={onAddHotel}
          suggested
          hotelCardProps={hotelCardProps}
        />
      ))}

      {showAvailable &&
        hotels.available.map((hotel) => (
          <TripMapHotelMarker
            key={'map-h-' + hotel?.id}
            hotel={hotel}
            onAdd={onAddHotel}
            hotelCardProps={hotelCardProps}
          />
        ))}
    </>
  );
}
